/**
 * The pure half of the consoles' "Report a wrong word" (ReportWrongWord.tsx).
 */

export interface WrongWordEntry {
  key: string;
  /** In the reader's language, `{placeholders}` unfilled. */
  text: string;
  english: string;
}

/** `{medication}` as "…": the catalogue's sentence, never somebody's filled-in one. */
export function displayTemplate(template: string): string {
  return template.replace(/\{\w+\}/g, '…');
}

/**
 * The strings whose words are on the page: every piece between its
 * placeholders appears in the page's text. Pieces shorter than three
 * characters do not count, so "{name}:" is never "on" every page.
 */
export function stringsOnPage(entries: readonly WrongWordEntry[], pageText: string, limit = 80): WrongWordEntry[] {
  const page = pageText.replace(/\s+/g, ' ');
  const out: WrongWordEntry[] = [];
  for (const e of entries) {
    const pieces = e.text.split(/\{\w+\}/).map((p) => p.replace(/\s+/g, ' ').trim()).filter((p) => p.length >= 3);
    if (pieces.length > 0 && pieces.every((p) => page.includes(p))) {
      out.push(e);
      if (out.length >= limit) break;
    }
  }
  return out;
}

/** Search the reader's language and the English, ignoring case and accents. */
export function searchEntries(entries: readonly WrongWordEntry[], query: string, limit = 40): WrongWordEntry[] {
  const fold = (s: string) => s.normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase();
  const q = fold(query.trim());
  if (!q) return [];
  const out: WrongWordEntry[] = [];
  for (const e of entries) {
    if (fold(displayTemplate(e.text)).includes(q) || fold(displayTemplate(e.english)).includes(q)) {
      out.push(e);
      if (out.length >= limit) break;
    }
  }
  return out;
}
